<template>
  <div class="paragraph-list">
    <div class="paragraph-list-item" v-for="(header, index) in headers" :key="header">
      <p class="header" v-html="header" />
      <p class="paragraph" v-html="paragraphs[index]" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParagraphList',
  props: {
    headers: {
      type: Array,
      required: true,
    },
    paragraphs: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#app {
  .paragraph-list {
    b {
      font-weight: bolder;
    }

    ul {
      list-style: disc;
    }
  }
}
</style>

<style lang="scss" scoped>
.paragraph-list {
  padding: 20px 12px;

  .paragraph-list-item {
    display: flex;
    flex-direction: column;

    .header {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}
</style>
